import React from 'react'

interface LinkedInIconProps {
  size?: number
  className?: string
}

export const LinkedInIcon: React.FC<LinkedInIconProps> = ({
  size = 24,
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size * (21 / 24)}
      viewBox="0 0 24 21"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_1100_12639)">
        <rect x="2" y="3" width="16" height="15" fill="#D9D9D9" />
        <path
          d="M17.2904 17.4012H14.2835V12.7984C14.2835 11.7009 14.2635 10.288 12.7196 10.288C11.1535 10.288 10.9139 11.4838 10.9139 12.7185V17.4009H7.907V7.93576H10.7936V9.22927H10.834C11.1229 8.74647 11.5404 8.3493 12.0419 8.08006C12.5434 7.81081 13.1103 7.67958 13.6821 7.70032C16.7297 7.70032 17.2916 9.65973 17.2916 12.2088L17.2904 17.4012ZM4.51423 6.64194C4.16912 6.642 3.83173 6.54203 3.54474 6.35466C3.25775 6.1673 3.03407 5.90096 2.90194 5.58933C2.76981 5.27769 2.73518 4.93476 2.80245 4.60389C2.86972 4.27303 3.03586 3.96909 3.27985 3.73052C3.52384 3.49194 3.83473 3.32944 4.1732 3.26357C4.51167 3.1977 4.86252 3.23142 5.18139 3.36045C5.50026 3.48949 5.77282 3.70805 5.96461 3.9885C6.15639 4.26895 6.2588 4.5987 6.25886 4.93603C6.2589 5.16002 6.2138 5.38181 6.12615 5.58876C6.03849 5.79571 5.91001 5.98376 5.74801 6.14216C5.586 6.30057 5.39365 6.42624 5.18196 6.51199C4.97027 6.59774 4.74338 6.6419 4.51423 6.64194ZM6.01767 17.4012H3.00766V7.93576H6.01767V17.4012ZM18.7894 0.501351H1.4967C1.10421 0.497022 0.725989 0.645182 0.445194 0.913275C0.164399 1.18137 0.00399675 1.54746 -0.000793457 1.9311V18.9041C0.0038328 19.288 0.164141 19.6543 0.444926 19.9227C0.725712 20.191 1.10401 20.3395 1.4967 20.3354H18.7894C19.1829 20.3402 19.5623 20.1922 19.8442 19.9238C20.1261 19.6555 20.2874 19.2887 20.2929 18.9041V1.92988C20.2873 1.54547 20.1258 1.17897 19.8439 0.91088C19.562 0.642794 19.1827 0.495056 18.7894 0.500126"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1100_12639">
          <rect
            width="24"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
